import React, {FC, useMemo} from 'react';
import {useGetUserQuery} from 'modules/user/services';

const sanitizePhoneToEmail = (phone?: string): string | undefined => {
    if (!phone) {
        return undefined;
    }

    const phoneDigitsOnly = phone.replace(/\D+/gu, '');
    if (!phoneDigitsOnly) {
        return undefined;
    }

    return `${phoneDigitsOnly}@unknown.email`;
};

export const FlocktoryIdentity: FC = () => {
    const {data: user} = useGetUserQuery();

    const isAuthorized = Boolean(user?.isAuthorized);

    const {userName, userEmail} = useMemo(() => {
        const firstName = (user?.firstName || '').trim();
        const lastName = (user?.lastName || '').trim();
        const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();

        const email = (user?.email || '').trim();
        const phone = (user?.phone || '').trim();

        const computedEmail = email || sanitizePhoneToEmail(phone) || '';

        return {
            userName: fullName || undefined,
            userEmail: computedEmail,
        };
    }, [user?.firstName, user?.lastName, user?.email, user?.phone]);

    if (!isAuthorized || !userEmail) {
        return null;
    }

    return <div className={'i-flocktory'} data-fl-user-name={userName} data-fl-user-email={userEmail} />;
};

export default FlocktoryIdentity;
